import React from "react";
import { Modal, Row, Col } from "antd";
import momentTZ from "moment-timezone";
import { getCarName } from "../../../../Utils";

const RowForm = props => (
  <Row style={{ padding: " 5px 10px" }}>{props.children}</Row>
);

class ModalReverse extends React.Component {
  state = {
    modalConfirm: false,
  };

  // Request //
  reverseRequest(data) {
    const carName = getCarName(
      data.id ? data.ApprovalTradeIn.Appraisal.carDetail : null
    );
    return data.id ? (
      <Modal
        title="Detail Request"
        visible={this.props.visible}
        confirmLoading={this.props.confirmLoading}
        onOk={() => this.setState({ modalConfirm: true })}
        onCancel={() => this.props.visibleModal(false, {})}
        okText="Reverse"
        width={700}>
        <p>Detail Request {data.status_label}</p>

        <RowForm>
          <Col span={8}>No. Polisi</Col>
          <Col span={16}>: {data.ApprovalTradeIn.Appraisal.licensePlate}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Mobil Bekas</Col>
          <Col span={16}>: {carName}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Mobil Baru</Col>
          <Col span={16}>: {data.ApprovalTradeIn.NewCar.carName}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>No. Booking</Col>
          <Col span={16}>
            : {data.ApprovalTradeIn.Appraisal.Booking.noBooking}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Salesman</Col>
          <Col span={16}>
            :{" "}
            {data.ApprovalTradeIn.Appraisal.Booking.SalesProfile
              ? data.ApprovalTradeIn.Appraisal.Booking.SalesProfile.name
              : null}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Cabang</Col>
          <Col span={16}>
            :{" "}
            {data.ApprovalTradeIn.Appraisal.Booking.SalesProfile.Branch
              ? data.ApprovalTradeIn.Appraisal.Booking.SalesProfile.Branch
                  .branch
              : null}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nominal Request</Col>
          <Col span={16}>
            :{" "}
            {data.requestPriceEdited
              ? data.requestPriceEdited
              : data.requestPrice}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Tanggal Approved</Col>
          <Col span={16}>
            :{" "}
            {momentTZ(data.updatedAt)
              .tz("Asia/Jakarta")
              .format("dddd, D MMMM YYYY HH:mm")}
          </Col>
        </RowForm>

        {/* Modal Confirm */}
        <Modal
          title="Konfirmasi"
          visible={this.state.modalConfirm}
          onOk={() => this.onSubmitReverse(data.id, "request")}
          onCancel={() => this.setState({ modalConfirm: false })}
          okText="Submit"
          width={400}>
          Apakah anda yakin akan cancel Request {data.status_label} ini?
        </Modal>
      </Modal>
    ) : null;
  }

  // Approval //
  reverseApproval(data) {
    const carName = getCarName(data.id ? data.Appraisal.carDetail : null);
    return data.id ? (
      <Modal
        title="Detail Approval"
        visible={this.props.visible}
        confirmLoading={this.props.confirmLoading}
        onOk={() => this.setState({ modalConfirm: true })}
        onCancel={() => this.props.visibleModal(false, {})}
        okText="Reverse"
        width={700}>
        <p>Detail Approval {data.statusApproval}</p>

        <RowForm>
          <Col span={8}>No. Polisi</Col>
          <Col span={16}>: {data.Appraisal.Booking.noBooking}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Mobil Bekas</Col>
          <Col span={16}>: {carName}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Mobil Baru</Col>
          <Col span={16}>: {data.NewCar.carName}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>No. Booking</Col>
          <Col span={16}>: {data.Appraisal.Booking.noBooking}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Salesman</Col>
          <Col span={16}>
            :{" "}
            {data.Appraisal.Booking.SalesProfile
              ? data.Appraisal.Booking.SalesProfile.name
              : null}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Cabang</Col>
          <Col span={16}>
            :{" "}
            {data.Appraisal.Booking.SalesProfile.SalesBranch
              ? data.Appraisal.Booking.SalesProfile.SalesBranch.branch
              : null}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Tanggal Selesai</Col>
          <Col span={16}>
            :{" "}
            {momentTZ(data.updatedAt)
              .tz("Asia/Jakarta")
              .format("dddd, D MMMM YYYY HH:mm")}
          </Col>
        </RowForm>

        {/* Modal Confirm */}
        <Modal
          title="Konfirmasi"
          visible={this.state.modalConfirm}
          onOk={() => this.onSubmitReverse(data.id, "approval")}
          onCancel={() => this.setState({ modalConfirm: false })}
          okText="Submit"
          width={400}>
          Apakah anda yakin akan cancel Approval ini?
        </Modal>
      </Modal>
    ) : null;
  }

  onSubmitReverse(id, type) {
    this.setState({ modalConfirm: false });
    if (type === "request") return this.props.cancelRequest(id);
    return this.props.cancelApproval(id);
  }

  render() {
    const { type, data } = this.props;
    if (type === "request") return this.reverseRequest(data);
    return this.reverseApproval(data);
  }
}

export default ModalReverse;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Modal/ModalReverse.js